import { createRoot } from 'react-dom/client';
import App from './App.js';
import { installGrowingTextareas } from './components/growTextareas.js';

// Every .form-textarea grows with its text instead of scrolling inside a resizable box —
// installed once, before render, so even the first modal opens with true heights.
installGrowingTextareas();

const root = createRoot(document.getElementById('root')!);
root.render(<App />);
